var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5902 18.5663V22.4699H13.3372V18.5663H9.43359V15.3133H13.3372V11.4097H16.9155V15.3133H20.4938V18.5663H16.5902Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 5.32831,
    width: 28.4277,
    height: 21.9217,
    rx: 2.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4938 2V4.57831C20.4938 4.75797 20.3482 4.90361 20.1685 4.90361H10.4336C9.88131 4.90361 9.43359 4.4559 9.43359 3.90362V2C9.43359 1.44772 9.88131 1 10.4336 1H19.4938C20.0461 1 20.4938 1.44771 20.4938 2Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.00d6f475498d1f6f55ceb5a988166ca6.svg";
export { ForwardRef as ReactComponent };